export const questionnaireEvaluationInitializationPostReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { evaluationDocId: action.payload, isSaveSuccess: false });
};
//# sourceMappingURL=questionnaireEvaluationInitializationPostReducer.js.map